module.exports = __webpack_public_path__ + "img/325ab15e8ecfeb7113edc9ebaeb6bb73.9df1e7e9.jpg";